export const SET_USER = "SET_USER";
export const LOGIN_USER_START = "LOGIN_USER_START";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAIL = "LOGIN_USER_FAIL";

export const REGISTER_USER_START = "REGISTER_USER_START";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";

export const EDIT_RECIPE_START = "EDIT_RECIPE_START";
export const EDIT_RECIPE_SUCCESS = "EDIT_RECIPE_SUCCESS";
export const EDIT_RECIPE_FAIL = "EDIT_RECIPE_FAIL";

export const DELETE_RECIPE_START = "DELETE_RECIPE_START";
export const DELETE_RECIPE_SUCCESS = "DELETE_RECIPE_SUCCESS";
export const DELETE_RECIPE_FAIL = "DELETE_RECIPE_FAIL";

export const FETCH_RECIPES_START = "FETCH_RECIPES_START";
export const FETCH_RECIPES_SUCCESS = "FETCH_RECIPES_SUCCESS";
export const FETCH_RECIPES_FAIL = "FETCH_RECIPES_FAIL";

export const SEARCH_RECIPES_START = "SEARCH_RECIPES_START";
export const SEARCH_RECIPES_SUCCESS = "SEARCH_RECIPES_SUCCESS";
export const SEARCH_RECIPES_FAIL = "SEARCH_RECIPES_FAIL";

export const FETCH_RECIPES_BY_ID_FAIL = "FETCH_RECIPES_BY_ID_FAIL";
export const FETCH_RECIPES_BY_ID_START = "FETCH_RECIPES_BY_ID_START";
export const FETCH_RECIPES_BY_ID_SUCCESS = "FETCH_RECIPES_BY_ID_SUCCESS";

export const LOAD_RECIPE_TO_EDIT_START = "LOAD_RECIPE_TO_EDIT_START";
export const LOAD_RECIPE_TO_EDIT_SUCCESS = "LOAD_RECIPE_TO_EDIT_SUCCESS";
export const LOAD_RECIPE_TO_EDIT_FAIL = "LOAD_RECIPE_TO_EDIT_FAIL";


export const DELETE_RECIPE = "DELETE_RECIPE"
export const USER_LOGOUT = "USER_LOGOUT"